import type { OrganizationTreeOptions } from "@/modules/organization/organization-tree";

import { Card } from "antd";

import { useOrganizationContextId } from "@/modules/organization/organization-context";
import { OrganizationTree } from "@/modules/organization/organization-tree";

export const OrganizationTreeCard = (options: OrganizationTreeOptions) => {
  const { contextId } = useOrganizationContextId();

  return (
    <Card
      classNames={{
        root: "organization-tree-card",
        body: "organization-tree-card--body",
      }}
    >
      <OrganizationTree organizationId={contextId} {...options} />
    </Card>
  );
};
